import React, { useCallback, useEffect, useState } from "react";
import "./changelog.scss";
import { IAuth, actionDisplayChangelog, useAppDispatch } from "@Store";
import { useDisplayChangelog } from "@Hooks";
import { useTranslation } from "react-i18next";
import { Sider } from "@Components/misc";
import { IChangelogHistory } from "./changelog.history";
import { ChangelogHistoryVersion } from "./changelog.history.version";

interface IProps {
  auth: IAuth;
}

export const useChangeLogHistory = () => {
  const [history, setHistory] = useState<Array<IChangelogHistory>>([]);

  useEffect(() => {
    const assetDomain = `${
      process.env.REACT_APP_MY_DOMAIN ??
      "https://s3.eu-central-1.amazonaws.com/atlas-dev.connectel.app"
    }/VERSION.json`;

    fetch(assetDomain)
      .then((v) => v.json())
      .catch(() => {})
      .then((v) => {
        if (v) setHistory(v);
      });
  }, []);

  return history;
};
export const Changelog = React.memo(({ auth }: IProps) => {
  const { t } = useTranslation();

  const displayed = useDisplayChangelog();
  const dispatch = useAppDispatch();
  const history = useChangeLogHistory();

  const toggle = useCallback(() => {
    dispatch(actionDisplayChangelog(!displayed));
  }, [displayed, dispatch]);

  return (
    <Sider
      onClose={() => {
        toggle();
      }}
      classNames={["changelog"]}
    >
      <h2>{t("CHANGELOG")}</h2>
      <ul className="versions">
        {history.map((history, index) => (
          <ChangelogHistoryVersion expanded={index < 7} t={t} history={history} />
        ))}
      </ul>
    </Sider>
  );
});
